const dev = process.env.NODE_ENV != "production";

// export const server = dev ? 'http://127.0.0.1:8000' : 'https://crescendoimvest.fr'
export const server = "https://www.crescendoimvest.fr";
